import { render, staticRenderFns } from "./wtFaceOnCamera.component.vue?vue&type=template&id=c03f1bc6&scoped=true&"
import script from "./wtFaceOnCamera.component.vue?vue&type=script&lang=js&"
export * from "./wtFaceOnCamera.component.vue?vue&type=script&lang=js&"
import style0 from "./wtFaceOnCamera.component.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wtFaceOnCamera.component.vue?vue&type=style&index=1&id=c03f1bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03f1bc6",
  null
  
)

export default component.exports